"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStandardSuggestions = void 0;
const tslib_1 = require("tslib");
const toCompletionItem_1 = require("../utils/toCompletionItem");
// Given standard and custom registered suggestions and kinds of suggestion expected, return a list of completion items
const getStandardSuggestions = (monaco, currentToken, suggestionKinds, positionContext, suggestionsRegistry) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    let suggestions = [];
    const invalidRangeToken = (currentToken === null || currentToken === void 0 ? void 0 : currentToken.isWhiteSpace()) ||
        (currentToken === null || currentToken === void 0 ? void 0 : currentToken.isParenthesis()) ||
        ((currentToken === null || currentToken === void 0 ? void 0 : currentToken.isIdentifier()) && currentToken.value.endsWith('.'));
    const range = invalidRangeToken || !(currentToken === null || currentToken === void 0 ? void 0 : currentToken.range)
        ? monaco.Range.fromPositions(positionContext.position)
        : currentToken === null || currentToken === void 0 ? void 0 : currentToken.range;
    // iterating over Set to deduplicate
    for (const suggestion of [...new Set(suggestionKinds)]) {
        const registeredSuggestions = suggestionsRegistry.getIfExists(suggestion);
        if (registeredSuggestions) {
            const su = yield registeredSuggestions.suggestions(Object.assign(Object.assign({}, positionContext), { range }), monaco);
            suggestions = [...suggestions, ...su.map((s) => (0, toCompletionItem_1.toCompletionItem)(s.label, range, Object.assign({ kind: s.kind }, s)))];
        }
    }
    return Promise.resolve(suggestions);
});
exports.getStandardSuggestions = getStandardSuggestions;
//# sourceMappingURL=getStandardSuggestions.js.map